import http from '../utils/http';

/**
 * 通过账号密码登录
 * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#122
 *
 * @param {String} userName
 * @param {String} password md5后的密码
 * @returns Promise
 */
export default function (userName, password) {

    return http.post('/login', {
        userName,
        password
    }, {
        showLoading: '登录中...',
        errorMsg: false,
        needLogin: false,
    })
}


